import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <h1 className="about-title">About Our College</h1>

      <section className="about-section">
        <p>
          <strong>GRAM VIKAS INTER COLLEGE KHUTHAN JAUNPUR</strong> was established in 1952 and is managed by a Pvt. Aided body. It is located in a rural area in the KHUTHAN block of JAUNPUR district, Uttar Pradesh. The school offers education from Grades 6 to 12 and is Co-educational. It does not include a pre-primary section.
        </p>

        <p>
          The school conducts its sessions in Hindi and starts its academic year in April. The school is easily accessible by an all-weather road and is not a shift-school.
        </p>
      </section>

      <section className="about-grid">
        <div><strong>Building Type:</strong> Private</div>
        <div><strong>Classrooms:</strong> 25 (All in good condition)</div>
        <div><strong>Extra Rooms:</strong> 2 for non-teaching, 1 for Headmaster</div>
        <div><strong>Boundary:</strong> Pucca wall</div>
        <div><strong>Electricity:</strong> Yes</div>
        <div><strong>Water Source:</strong> Functional Hand Pumps</div>
        <div><strong>Toilets:</strong> 3 Boys, 3 Girls (All Functional)</div>
        <div><strong>Playground:</strong> Not available</div>
        <div><strong>Library:</strong> Available (100 books)</div>
        <div><strong>Computers:</strong> 10 (All Functional)</div>
        <div><strong>Computer Lab:</strong> Not Available</div>
        <div><strong>Mid-Day Meal:</strong> Provided & prepared on school premises</div>
      </section>

      <section className="about-location">
        <h2>Our Location</h2>
        <p>
          Visit us at: <a href="https://maps.app.goo.gl/dasjgabZsGmfsbZU8" target="_blank" rel="noopener noreferrer">Google Maps</a>
        </p>
        <iframe
          title="College Location"
          src="https://maps.google.com/maps?q=GRAM+VIKAS+INTER+COLLEGE+KHUTHAN+JAUNPUR&t=&z=15&ie=UTF8&iwloc=&output=embed"
          frameBorder="0"
          allowFullScreen=""
        ></iframe>
      </section>
    </div>
  );
};

export default About;
